query TravelerAlias($id: UUID!) {
  travelerAlias(id: $id) {
    _rowTimestamp
    companyOrLastName
    firstName
    nameAlias
    _isUpdatable
  }
}
